<template>
  <div class="cinema-list">
    <div 
      v-for="(item, index) in list" 
      :key="index" 
      class="cinema-card" 
      @click="goDetail(item)">
      
      <!-- 影院名称（完整显示） -->
      <div class="cinema-name">{{ item.cinemaName }}</div>
      
      <!-- 地址行：地址 + 距离 -->
      <div class="cinema-info">
        <div class="cinema-addr">
          <van-icon name="location-o" size="0.9rem" color="#999" />
          <span>{{ item.cinemaAddr }}</span>
        </div>
        <div v-if="getKm(item.gap)" class="cinema-distance">
          {{ getKm(item.gap) }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CinemaItem",
  props: {
    list: {
      type: Array,
      default: () => []
    },
  },
  methods: {
    getKm(gap) {
      if (!gap || gap === '0.0') {
        return ''
      }
      if (gap > 1000) {
        return '>1000km'
      } else {
        return gap + 'km'
      }
    },
    goDetail(val) {
      this.$router.push({
        path: "/CinemaDetail",
        query: {
          cinemaId: val.cinemaId,
          name: val.cinemaName,
          address: val.cinemaAddr,
          distance: this.getKm(val.gap), // 传递距离
        },
      });
    },
  },
};
</script>

<style lang='scss' scoped>
.cinema-list {
  background-color: transparent;
}

.cinema-card {
  background-color: #fff;
  border-radius: 0.8rem;
  margin-bottom: 0.6rem;
  padding: 1rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  
  &:active {
    background-color: #f9f9f9;
  }
}

.cinema-name {
  font-size: 1.05rem;
  font-weight: 600;
  color: #333;
  line-height: 1.5;
  margin-bottom: 0.6rem;
  /* 名称完整显示，不截断 */
  word-break: break-word;
}

.cinema-info {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 0.8rem;
}

.cinema-addr {
  flex: 1;
  display: flex;
  align-items: flex-start;
  gap: 0.3rem;
  font-size: 0.85rem;
  color: #999;
  line-height: 1.5;
  
  /* 地址可换行显示 */
  span {
    word-break: break-word;
  }
  
  .van-icon {
    flex-shrink: 0;
    margin-top: 0.15rem;
  }
}

.cinema-distance {
  flex-shrink: 0;
  font-size: 0.85rem;
  color: #ee0a24;
  font-weight: 500;
  white-space: nowrap;
}
</style>